import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => (
  <main className="sf-page sf-not-found" aria-labelledby="not-found-title">
    <section className="container py-5 text-center">
      <h1 id="not-found-title">Page not found</h1>
      <p>The page you requested is not available.</p>
      <Link className="btn btn-primary" to="/">Return to the home page</Link>
    </section>
  </main>
);

export default NotFound;
